import { Component, OnInit, NgZone } from '@angular/core';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { CstemapiService } from '../cstemapi.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
declare var Highcharts: any;
import * as $ from 'jquery';

@Component({
  selector: 'app-outputplantdesign',
  templateUrl: './outputplantdesign.component.html',
  styleUrls: ['./outputplantdesign.component.scss']
})
export class OutputplantdesignComponent implements OnInit {
  chart1: any;
  pvModule;
  timeWindow: any;
  twReport: any;
  twSummary;
  twSummaryPVdetails: any = [];
  chooseoptions: any;
  batterySizing: any;
  reductionFactor: any = [];
  rowName: any = [];
  ctx: any;
  reductionArr = [];
  redFac: any;
  redFacData1: any = [];
  redFacData2: any = [];

  constructor(private zone: NgZone, private cstemapi: CstemapiService, private myRoute: Router, private auth: AuthService) {
    this.getPlantSizingDetails();
    this.timeWindow = 'activeGenerationHours';
    this.chooseoptions = this.auth.getAppCode();
    // console.log(this.chooseoptions)

  }

  ngOnInit() {
    this.timeWindowBasedSummary();
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    window.scroll(0, 0);
    let top = document.getElementById('modulesizing');
    if (top != null) {
      top.scrollIntoView();
      top = null;
    }

    $(document).ready(function () {
      $('.sidelinks-sm').click(function () {
        $('.sidelinks').toggle();
      })
    })
  }

  ngAfterViewInit() {
    am4core.useTheme(am4themes_animated);
  }

  getPlantSizingDetails() {
    var dObj = {
      userId: this.auth.getUserId(),
      plantId: this.auth.getPlantId()
    }
    var api = 'reports/getPlantSizingDetails'
    this.cstemapi.cstemAPI(dObj).GetPlantSizingDetails.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.pvModule = resData.pvDetails;
        this.batterySizing = resData.batterySizing;
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', 'Error while getting plant sizing details', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  timeWindowBasedSummary() {
    var dObj = {
      userId: this.auth.getUserId(),
      plantId: this.auth.getPlantId()
    };
    var api = 'reports/timeWindowBasedAnalysisSummary'
    this.cstemapi.cstemAPI(dObj).GetTimeWindowBasedSummary.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.twSummary = resData.timeWindowReport;
        this.twSummaryPVdetails = resData.timeWindowReport[0].pvDetails;
        for (var i = 0; i < resData.timeWindowReport[0].pvDetails.length; i++) {
          this.rowName.push({ startTime: resData.timeWindowReport[0].pvDetails[i].startTime, endTime: resData.timeWindowReport[0].pvDetails[i].endTime })
        }
        if (this.rowName.length == 4) {
          this.timeWindowChange();
        }
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', 'Error while getting time window based summary', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  timeWindowChange() {
    var dObj = {
      userId: this.auth.getUserId(),
      plantId: this.auth.getPlantId(),
      type: this.timeWindow
    };
    var api = 'reports/timeWindowBasedAnalysis'
    this.cstemapi.cstemAPI(dObj).GetTimeWindowBasedAnalysis.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.twReport = resData.timeWindowReport;
        this.redFac = false;
        this.reductionFactor = [];
        var ddata = [];
        for (var i = 0; i < this.twReport.length; i++) {
          ddata.push({
            rName: this.rowName[i].startTime + ' to ' + this.rowName[i].endTime,
            rValue: this.twReport[i]
          })
          this.reductionArr.push(this.rowName[i].startTime + ' to ' + this.rowName[i].endTime)
        }
        // console.log(this.reductionArr)

        if (ddata.length == this.twReport.length) {
          this.reductionFactor.push({
            v1: (ddata[0].rValue / ddata[1].rValue).toFixed(2)
          }, {
            v1: (ddata[1].rValue / ddata[2].rValue).toFixed(2)
          }, {
            v1: (ddata[0].rValue / ddata[2].rValue).toFixed(2)
          }, {
            v1: (ddata[0].rValue / ddata[2].rValue).toFixed(2)
          })

          this.redFacData1 = [];
          this.redFacData2 = [];

          for (var i = 0; i < ddata.length; i++) {
            let rnum: any;
            let rnum1: any;

            for (var j = 0; j < ddata.length - (i); j++) {
              rnum = parseFloat((ddata[i].rValue / ddata[ddata.length - (j + 1)].rValue).toFixed(2));
              rnum1 = parseFloat((ddata[ddata.length - (j + 1)].rValue / ddata[i].rValue).toFixed(2));
              // console.log(rnum)
              this.redFacData1.push([i, j, rnum]);
              this.redFacData2.push([i, j, rnum1])
            }
          }

          // this.areaPlantChart(ddata);
          this.areaPlantChart(this.reductionArr, this.twReport)
          this.reductionChart(this.redFacData1);
          // console.log(ddata)
        }
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', resData.statusMessage, 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  areaPlantChart(xdata, ydata) {
    var un;
    if (this.timeWindow == 'plantArea') {
      un = 'Acres'
    } else if (this.timeWindow == 'activeGenerationHours') {
      un = 'Hour'
    } else if (this.timeWindow == 'annualPvGeneration') {
      un = 'MWh'
    } else {
      un = 'MWh / sq.m'
      // un = 'MWh'
    }

    Highcharts.chart('jjjj', {
      chart: {
        type: 'column'
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: xdata,
        labels: {
          style: this.cstemapi.h_x_y_format
        },
      },
      yAxis: {
        labels: {
          style: this.cstemapi.h_x_y_format
        },
        title: {
          text: un,
          style: this.cstemapi.h_x_y_title_format
        }
      },
      tooltip: {
        formatter: function () {
          return this.point.category + ': <b>' + this.point.y + ' ' + un + '</b>';
        },
        style: this.cstemapi.h_x_y_tooltip_format
      },
      series: [{
        name: un,
        data: ydata,
        showInLegend: false
      }]
    });

  }

  reductionChart(data) {
    // console.log(data)

    Highcharts.chart('reductionfactor', {

      chart: {
        type: 'heatmap',
        marginTop: 13,
        marginBottom: 80,
        plotBorderWidth: 1
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: this.reductionArr,
        labels: {
          style: this.cstemapi.h_x_y_format
        },
        title: {
          text: 'a',
          style: this.cstemapi.h_x_y_title_format
        }
      },
      yAxis: {
        categories: [this.reductionArr[3], this.reductionArr[2], this.reductionArr[1], this.reductionArr[0]],
        labels: {
          style: this.cstemapi.h_x_y_format
        },
        title: {
          text: 'b',
          style: this.cstemapi.h_x_y_title_format
        }
      },
      colorAxis: {
        min: 0,
        minColor: '#FFFFFF',
        maxColor: Highcharts.getOptions().colors[0]
      },
      legend: {
        align: 'right',
        layout: 'vertical',
        margin: 0,
        verticalAlign: 'top',
        y: 25,
        symbolHeight: 280
      },
      tooltip: {
        formatter: function () {
          return '<b>' + this.point.value + '</b>';
        },
        style: this.cstemapi.h_x_y_tooltip_format
      },
      // exporting: { enabled: false },
      series: [{
        name: 'Reduction Factor',
        borderWidth: 1,
        data: data,
        dataLabels: {
          enabled: true,
          color: '#000000'
        }
      }]
    });
  }

  tConv24(time24) {
    var ts = time24;
    var H = +ts.substr(0, 2);
    var h: any = (H % 12) || 12;
    h = (h < 10) ? ("0" + h) : h;  // leading 0 at the left for 1 digit hours
    var ampm = H < 12 ? " AM" : " PM";
    ts = h + ts.substr(2, 3) + ampm;
    return ts;
  };

  scrollToView(id) {
    var elmnt = document.getElementById(id);
    elmnt.scrollIntoView({
      behavior: 'smooth'
    });
  }

  reductionChange() {
    // console.log(this.redFac);
    if (this.redFac) {
      this.reductionChart(this.redFacData2)
    } else {
      this.reductionChart(this.redFacData1)
    }

  }
}
